<file-manager [initialPath]="initialPath" [featureKey]="'COMPLIANCE_FILE_MANAGER'"></file-manager>

